import React, { useEffect } from 'react'
import Module from '../../../../layout/Module'
import Tabs from '../Tabs'
import DataGrid from '../../../../table/DataGrid'
import useMySurveys from '../../../../../hooks/data-entry/useMySurver'
import { useSelector } from 'react-redux'
import FormatDate from '../../../../date/FormatDate'
import StatusChip from '../../components/StatusChip/StatusChip'
import DialogPreviewAboutMe from '../../components/DialogPreviewAboutMe/DialogPreviewAboutMe'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import { Chip, Typography } from '@mui/material'
import { SURVEY_TYPE_ABOUT_CLASSES, SURVEY_TYPE_ABOUT_USERS } from '../../constants/typeSurvey'

const AboutMyClassesSurveyList = () => {
  const { getMySurveysAboutMyClasses, onShareLink } = useMySurveys()
  const [modal, setModal] = React.useState(null)

  const state = null
  const skip = useSelector((state) => state?.datatable?.aboutMyClassesSurverList?.skip || 0)
  const rowsPerPage = useSelector((state) => state?.datatable?.aboutMyClassesSurverList?.rowsPerPage || 50)
  const columnsTable = useSelector((state) => state?.datatable?.aboutMyClassesSurverList?.columnsTable || [])

  const list = useSelector((state) => state?.dataEntryMySurveys?.aboutMyClasses?.list ?? [])
  const totalRecords = useSelector((state) => state?.dataEntryMySurveys?.aboutMyClasses?.totalRecords ?? 0)
  const loading = useSelector((state) => state?.dataEntryMySurveys?.aboutMyClasses?.loading ?? false)

  useEffect(() => {
    getMySurveysAboutMyClasses(skip, rowsPerPage, state?.filter)
  }, [rowsPerPage, skip, state, state?.filter])

  const getStatusChip = (survey) => {
    let type = ''
    let content = ''

    if (survey?.hasExpired) {
      type = 'error'
      content = 'Closed'
    } else {
      type = 'active'
      content = 'Active'
    }
    return (
      <div className='flex items-center justify-center'>
        <StatusChip content={content} type={type} />
      </div>
    )
  }

  return (
    <Module>
      <Module.Header title='My Surveys' titleLink={'/dashboard/data-entry/my-surveys/about-my-classes'} />
      <Module.Body>
        <Module.BodyHeader>
          <Tabs />
        </Module.BodyHeader>
        <Module.BodyContainer classNameWrapper='overflow-auto'>
          <DataGrid
            id='table-mysurveys-about-me'
            loading={loading}
            rows={list.map((row, index) => ({
              ...row,
              index: index + 1,
              // name: row?.name || '-',
              name: (
                <div>
                  <Typography>{row?.name || '-'}</Typography>
                  {[SURVEY_TYPE_ABOUT_CLASSES, ...SURVEY_TYPE_ABOUT_USERS].includes(row?.type) && (
                    <Chip
                      size='small'
                      variant='outlined'
                      label={
                        <>
                          <b>{row?.classes?.code?.split('-').join(' ')}</b>
                          <span className='pl-2'>{row?.type || '-'}</span>
                        </>
                      }
                    />
                  )}
                </div>
              ),
              creator: row?.createdBy?.fullName || '',
              questions:
                row.template?.questions?.filter((question) => question?.type?.value !== 'groupreference')
                  ?.length || 0,
              status: <>{getStatusChip(row)}</>,
              completed: (() => {
                const done = row?.classResultsLength ?? row?.resultsLength ?? 0
                const total = row?.classes?.students?.length || 0
                const pending = Math.max(0, total - done)
                const pct = total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 0
                return (
                  <div className='flex flex-col items-center gap-0.5'>
                    <span>
                      {done} user{done !== 1 ? 's' : ''} ({pct}%)
                    </span>
                    {total > 0 && <span className='text-xs text-gray-400'>{pending} pending</span>}
                  </div>
                )
              })(),
              dateFilledOut: row?.result?.dateFilledOut ? (
                <FormatDate date={row?.result?.dateFilledOut} />
              ) : null,
              date: row?.dueDate ? <FormatDate date={row?.dueDate} /> : null,
              note: row?.notes || '',
              actions: (
                <div className='flex items-center gap-1 items-center justify-center'>
                  <IconTooltipButton
                    id={`survey-preview-${row._id}`}
                    disabled={loading}
                    title='Preview'
                    icon='expand-alt'
                    onClick={() =>
                      setModal({
                        open: true,
                        data: {
                          recordId: row?.classes?._id,
                          surveyId: row._id
                        }
                      })
                    }
                  />
                  {!row.hasExpired ? (
                    <IconTooltipButton
                      id={`share-link-${row._id}`}
                      disabled={loading}
                      title='Share link'
                      icon='share-alt'
                      onClick={() =>
                        onShareLink(row._id, {
                          _id: row?.classes?._id
                        })
                      }
                    />
                  ) : (
                    <div className='px-4' />
                  )}
                </div>
              )
            }))}
            labelNoRows="You don't have any survey yet"
            nameModule='mySurveysList'
            skip={skip}
            totalRows={totalRecords}
            rowsPerPage={rowsPerPage}
            columns={[
              {
                label: '#',
                key: 'index',
                align: 'center',
                width: 10,
                show: true,
                hide: false
              },
              ...columnsTable,
              {
                label: 'Actions',
                key: 'actions',
                align: 'center',
                show: true,
                hide: false
              }
            ]}
            orderByField='name'
          />
        </Module.BodyContainer>
      </Module.Body>
      {modal && (
        <DialogPreviewAboutMe
          surveyId={modal.data?.surveyId}
          recordId={modal.data?.recordId}
          open={modal.open}
          loading={loading}
          onClose={() => setModal(null)}
        />
      )}
    </Module>
  )
}

export default AboutMyClassesSurveyList
